import { getBackendUrl } from "@Utils";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { TextBoxComponent, FormValidator } from "@syncfusion/ej2-react-inputs";
import { Query } from "@syncfusion/ej2-data";
import { ChipDirective, ChipListComponent, ChipsDirective } from "@syncfusion/ej2-react-buttons";
import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";
import cloneObject from "../../services/cloneObject";
import { cubeView, getCubeViewSnapshot } from "../../services/cubeView";
import { getDefaultListOfStatusAvailable, saveIssuesData } from "../../actions/bcfData";
import css from "./CreateIssue.module.css";
import "./createIssue.css";
import axiosWrapper from "../../services/axiosWrapper";
import { HoopsViewerContext } from "../Viewer/ViewerContext";
import FileManagerAsPopup from "../FileManager/FileManagerAsPopup";
import { setAnnotations, setCurrentPagePDF, setModalStatus, setAnimationForIssueCreation } from "../../reducers/Viewer";
import MultiSelectComponent from "../../cubeComponent/form/MultiselectComponent";
import ButtonComponent from "../../cubeComponent/form/ButtonComponent";
import { BUTTON_TYPES } from "../../cubeComponent/constants/globalVariable";
import RichTextEditorComponent from "../../cubeComponent/form/RichTextEditorComponent";

import { PDF_ENGINE, TOAST_TYPE_WARNING } from "../../services/constants";
import html2canvas from "html2canvas";
import { defaultListOfStatusAvailableService, spaceUsersListService } from "../../services/dataManager";
import { getDropdownBackground, getStatusBtnStyle } from "../Reviews/ReviewsHelper";
import DropDownListComponent from "../../cubeComponent/form/DropdownListComponent";
import { showToastNotification } from "../../actions/toast";
import { formCategories } from "@Helpers";
import FormPreview from "../PortalSetings/Configuration/FormsAndFields/FormTemplate/formPreview";
import ImageEditor from "@Components/ImageEditor";
import { getUrlForImage } from "@CubeComponents/constants/globalFunctions";
import Accordion from "@CubeComponents/html/accordion/materialUiAccordian/index";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import IconComponent from "@CubeComponents/icons";
import { useParams } from "react-router-dom";
import _ from "lodash";
import { getFileImage } from "../../services/utils/iconMap";
import useFormValidator from "@Components/FormValidation/useFormValidator";
import { useTranslation } from "react-i18next";
import useViewerCallbacks from "@Components/Viewer/useViewerCallbacks";
import useFileVersionIdAndNodeOffsetIdMap from "@Services/cubeViewHelperHooks";
import { Box } from "@mui/material";

function CreateIssue(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const statusDropdownRef = useRef();
  const steverityDropdownRef = useRef();
  const { viewerImpl, isModelStructureReady } = useContext(HoopsViewerContext);
  const HoopsModalStatus = useSelector((state) => state.HoopsModalStatus);
  const annotationData = useSelector((state) => state.viewerState.markupAnnotations);
  const currentPageInfo = useSelector((state) => state.viewerState.currentPageInfo);
  const { projectData } = useSelector((state) => state);

  const defaultStatusId =
    HoopsModalStatus?.Issues?.currentStage == "edit_issue" ? props.editIssues.statusInReview?._id : null;
  const defaultStatusBackground =
    HoopsModalStatus?.Issues?.currentStage == "edit_issue"
      ? getDropdownBackground(props.editIssues.statusInReview.category)
      : null;

  const [issueTitle, setIssueTitle] = useState("");
  const [issueAttachedFiles, setIssueAttachedFiles] = useState([]);
  const [issueDescription, setIssueDescription] = useState("");
  const [assignedTo, setAssignedTo] = useState("");
  const [createButton, setCreateButton] = useState("Create");
  const [spaceId, setSpaceId] = useState();
  const [usersList, setUsersList] = useState(null);
  const [pinData, setPinData] = useState({});
  const [pinStatus, setPinStatus] = useState("NOT_STARTED");
  const [showFileManager, setShowFileManager] = useState(false);
  const [tagsDataSource, setTagsDataSource] = useState(["Severe", "Low", "Important"]);
  const [initialCustomTags, setInitialCustomTags] = useState([]);
  const [customTag, setCustomTag] = useState([]);
  const [actionButtons, setactionButtons] = useState(false);
  const [dueDate, setDueDate] = useState("");
  const [pdfRender] = useState([PDF_ENGINE].includes(props.engineType));
  const [Status, setStatus] = useState({
    _id: defaultStatusId,
    background: defaultStatusBackground,
  });
  const [formTemplate, setFormTemplate] = useState({});
  const [severity, setSeverity] = useState(null);
  const query = new Query().addParams("entityType", "ISSUES").addParams("spaceId", spaceId);
  const [clashIssueProgress, setClashIssueProgress] = useState(null);
  const [cancelClashIssue, setCancelClashIssue] = useState(false);
  const params = useParams();
  const [imageForStandaloneIssue, setImageForStandaloneIssue] = useState("");
  const [standaloneImageEdited, setStandaloneImageEdited] = useState(false);
  const formId = [];

  const offSet = useFileVersionIdAndNodeOffsetIdMap(params.fileId);

  const htmlAttributes = { maxlength: "256" };
  const fileVersionId = props.fileVersionId;
  const formObject = useRef(null);
  const formValidator = useFormValidator({});

  const severityTypes = [
    {
      id: "MINOR",
      text: t("Minor"),
    },
    {
      id: "MAJOR",
      text: t("Major"),
    },
  ];

  useEffect(() => {
    if (_.get(viewerImpl, "hwv") && _.get(HoopsModalStatus, "Issues.currentStage") !== "edit_issue") {
      const getAllMeasurements = viewerImpl.hwv.measureManager.getAllMeasurements();
      getAllMeasurements.forEach((markup) => viewerImpl.hwv.measureManager.removeMeasurement(markup));
    }
  }, []);

  useEffect(() => {
    const options = {
      rules: {
        title: {
          required: [true, t("Title is required")],
        },
        status: {
          required: [true, t("Status is required")],
        },
      },
    };
    formObject.current = new FormValidator("#createIssueForm", options);
  }, []);

  useEffect(() => {
    if (projectData._id && _.get(HoopsModalStatus, "Issues.currentStage") !== "edit_issue") {
      axiosWrapper
        .post(`${getBackendUrl()}/projects/getFormTemplate`, {
          projectId: projectData._id,
          resourceType: formCategories.issues,
        })
        .then(({ data }) => {
          setFormTemplate(data.data || {});
        });
    }
  }, [projectData]);

  useEffect(() => {
    if (props.transmittalVersionId) {
      if (props.transmittals && props.transmittals[props.transmittalVersionId]) {
        setSpaceId(props.transmittals[props.transmittalVersionId].TRANSMITTAL_TOSPACEIDS.value);
      }
    } else if (_.get(props, `filesData.${fileVersionId}`) && fileVersionId) {
      setSpaceId(props.filesData[fileVersionId].spaceId);
    }
  }, [props.filesData[fileVersionId], props.spacesUsersData, props.transmittals]);

  useEffect(() => {
    setUsersList(props.spacesUsersData.filter((space) => space.spaceId == spaceId));
  }, [spaceId]);

  useEffect(() => {
    props.workspaceId && setSpaceId(props.workspaceId);
  }, [props.workspaceId]);

  const handleIssueDescriptionChange = (args) => {
    setIssueDescription(args.value);
  };

  const insertImageSettings = { saveFormat: "Base64", display: "inline" };

  function dropdownItemTemplate(args) {
    const style = getStatusBtnStyle(args.category);

    return (
      <div className={css.itemTemplateWrapper}>
        <span style={style} className={css.itemTemplateContainer}>
          {args.name}
        </span>
      </div>
    );
  }

  const actionComplete = () => {
    if (_.get(HoopsModalStatus, "Issues.currentStage") == "edit_issue") {
      statusDropdownRef.current.value = Status._id;
    }
  };

  const validateData = () => {
    let formValidated = formObject.current.validate();
    if (formValidator.validateAll) {
      formValidated = formValidator.validateAll() && formValidated;
    }
    return formValidated;
  };

  const handleCreateIssue = async ({ clashDetails }) => {
    if (clashDetails || validateData()) {
      // TODO: handle spaceid from backend also
      if (!(Status._id || _.get(clashDetails, "status"))) {
        dispatch(
          showToastNotification({
            content: t("Please specify status of the issue"),
            type: TOAST_TYPE_WARNING,
          }),
        );
        return;
      }

      setactionButtons(true);

      let savedData = {
        fileId: fileVersionId,
        topicId: "dfsf",
        attachedReviewId: props.attachedReviewId,
        topicText: clashDetails ? _.get(clashDetails, "clashName") : issueTitle,
        description: issueDescription,
        status: clashDetails ? _.get(clashDetails, "status") : Status._id,
        assignedTo,
        dueDate,
        spaceId,
        attachedFiles: issueAttachedFiles.map((data) => data.fileVersionId),
        tagsData: customTag,
        formTemplate: clashDetails ? props.clashIssueData.formTemplate?.template : formTemplate?.template,
        severity,
        formId,
        ...props.extraParametersOnIssueCreation,
      };

      if (!pdfRender) {
        let viewpoint = "";
        let bcfData = "";
        let snapshot = standaloneImageEdited ? imageForStandaloneIssue : "";
        if (!props.isStandalone) {
          const viewPoints = await handleIssueViewPoint();
          snapshot = await handleTakeSnapshot();
          viewpoint = JSON.stringify(viewPoints[1]);
          bcfData = JSON.stringify(viewPoints[0]);
        }
        savedData = {
          ...savedData,
          viewpoint,
          bcfData,
          snapshot,
          pinData: JSON.stringify(pinData),
        };
      } else {
        let snapshot = await html2canvas(document.getElementById("pdfContainer"));
        snapshot = snapshot.toDataURL("base64");
        savedData.viewpoint = JSON.stringify(annotationData);
        savedData.snapshot = snapshot;
        savedData.pdfCurrentPage = currentPageInfo.pageNumber;
        savedData.zoomLevel = currentPageInfo.zoomLevel;
        savedData.xScrollPosition = currentPageInfo.xScrollPosition;
        savedData.yScrollPosition = currentPageInfo.yScrollPosition;
      }

      if (_.get(HoopsModalStatus, "Issues.currentStage") == "edit_issue") {
        savedData.id = props.editIssues.id;
      }
      // savedData.formTemplate = [];
      const status = await props.saveIssuesData(savedData, savedData.id);
      setactionButtons(false);
      if (status) {
        if (props.closeAddIssueModal) {
          props.closeAddIssueModal();
        }
        if (props.refreshDataGrid) {
          props.refreshDataGrid();
        }
        handleCancelIssue();
        dispatch(setAnimationForIssueCreation(true));
        setTimeout(() => {
          dispatch(setAnimationForIssueCreation(false));
        }, 1500);
      }
    } else {
      dispatch(
        showToastNotification({
          content: t("Please fill all mandatory fields"),
          type: TOAST_TYPE_WARNING,
        }),
      );
    }
  };

  const handleCancelIssue = () => {
    if (props.onCancel) {
      props.onCancel();
    }
    dispatch(
      setModalStatus({
        ...HoopsModalStatus,
        Issues: {
          ...HoopsModalStatus.Issues,
          currentStage: _.get(HoopsModalStatus, "Issues.defaultStage"),
          backStage: _.get(HoopsModalStatus, "Issues.defaultStage"),
        },
      }),
    );
  };

  const handleCustomFieldsData = (data) => {
    setFormTemplate((prev) => ({ ...prev, template: data }));
  };

  const handleIssueViewPoint = async () => {
    if (!hwv) return;
    let bcfData = await Communicator.BCFViewpoint.createViewpoint(hwv, "viewpoint.bcfv");
    delete bcfData._viewer;
    bcfData = cloneObject(bcfData);

    const viewpoint = await cubeView.toJson(viewerImpl);
    return [bcfData, viewpoint];
  };

  const handleTakeSnapshot = async () => await getCubeViewSnapshot();

  useEffect(() => {
    const viewerContainer = document.getElementById("viewerContainer");
    if (viewerContainer && !props.clashIssueData) {
      setTimeout(() => {
        viewerContainer.classList.add("animate-flash");
        setTimeout(() => {
          viewerContainer.classList.remove("animate-flash");
        }, 1000);
      }, 300);
    }
  }, []);

  const handleData = async () => {
    if (isModelStructureReady || pdfRender || props.isStandalone) {
      if (_.get(HoopsModalStatus, "Issues.currentStage") == "edit_issue") {
        const attachedFiles = [];
        if (props.editIssues.attachedFiles?.length) {
          props.editIssues.attachedFiles.map((file) => {
            attachedFiles.push({
              name: file.originalName,
              fileVersionId: file.fileVersionId,
              resourceType: file.resourceType,
            });
          });
        }
        setIssueTitle(props.editIssues.title.trim());
        setSeverity(props.editIssues.severity);
        setIssueDescription(props.editIssues.description);
        setAssignedTo(props.editIssues.assignedTo || "");
        setDueDate(props.editIssues.dueDate);
        if (props.editIssues.formTemplate) {
          setFormTemplate((prev) => ({
            ...prev,
            template: props.editIssues.formTemplate,
          }));
        }
        if (props.editIssues && props.isStandalone && props.editIssues.snapshot) {
          setImageForStandaloneIssue(getUrlForImage({ id: props.editIssues.id }, "IssueImage"));
        }
        setIssueAttachedFiles(attachedFiles);
        setTagsDataSource([...tagsDataSource, ...props.editIssues.tagData.split(",")]);

        const pinObj = JSON.parse(props.editIssues.pinData);
        if (viewerImpl) {
          await viewerImpl.loadMarkups([pinObj]);
          const markupToHighlight = findMarkupByGuid({
            guid: pinObj._uniqueId,
          });
          markupToHighlight?.[0]?.onSelect();
        }
        setPinData(pinObj);
        if (props.editIssues.tagData) {
          setInitialCustomTags(props.editIssues.tagData.split(","));
          setCustomTag(props.editIssues.tagData.split(","));
        }
        const viewPointValue = props.editIssues.viewpoint;
        const pdfIssuePage = props.editIssues.pdfCurrentPage;
        const pdfZoomLevel = props.editIssues.zoomLevel;
        const xScrollPosition = props.editIssues.xScrollPosition;
        const yScrollPosition = props.editIssues.yScrollPosition;

        if (pdfRender && viewPointValue) {
          dispatch(
            setCurrentPagePDF({
              pageNumber: pdfIssuePage,
              reason: "viewIssue",
              zoomLevel: pdfZoomLevel,
              xScrollPosition,
              yScrollPosition,
            }),
          );
          dispatch(setAnnotations({ data: JSON.parse(viewPointValue), annotationType: "markupAnnotations" }));
        }
      }
    }
  };
  useEffect(() => {
    handleData();
  }, [isModelStructureReady, props.editIssues]);

  useEffect(() => {
    if (props.triggerClashIssue) {
      initializeClashIssue();
    }
  }, [props.triggerClashIssue]);

  async function initializeClashIssue() {
    const index = props.clashIssueData.treeGrid.current.slickGrid.getSelectedRows();
    const selectedRecords = [];
    index.map((idx) => {
      selectedRecords.push(props.clashIssueData.treeGrid.current.slickGrid.getDataItem(idx));
    });
    const statusData = await getDefaultListOfStatusAvailable({
      spaceId,
      entityType: "ISSUES",
    });
    let issueStatus;
    statusData.data.result.map((data) => {
      if (data.name == "In Review") {
        issueStatus = data._id;
      }
    });
    setClashIssueProgress({
      total: selectedRecords.length,
      progress: 0,
      issueStatus,
      offSet,
      selectedRecords,
    });
  }

  useEffect(() => {
    if (clashIssueProgress) {
      createClashIssue();
    }
  }, [clashIssueProgress]);

  const createClashIssue = async () => {
    const selectedRecords = clashIssueProgress.selectedRecords;
    const i = clashIssueProgress.progress;
    if (cancelClashIssue || i == selectedRecords.length) {
      props.setTriggerClashIssue(false);
      setClashIssueProgress(null);
      setCancelClashIssue(false);
      return;
    }

    const record = selectedRecords[i];
    await props.clashIssueData.handleClickCollisionOutput({
      data: [record],
      offSet: clashIssueProgress.offSet,
    });

    await handleCreateIssue({
      clashDetails: {
        status: clashIssueProgress.issueStatus,
        clashName: record.clashName,
      },
    });

    setClashIssueProgress({
      ...clashIssueProgress,
      progress: i + 1,
    });
  };

  useEffect(() => {
    if (_.get(HoopsModalStatus, "Issues.currentStage") == "edit_issue") {
      setCreateButton("Save");
    } else {
      setCreateButton("Create");
    }
  }, [HoopsModalStatus]);

  const handleStatusChange = (event) => {
    if (event.target.isInteracted) {
      const _id = event.target.value;
      const { itemData } = event.target;
      const background = getDropdownBackground(itemData.category);

      setStatus({ _id, background });
    }
  };

  const handleSeverityChange = (event) => {
    const id = event.target.value;
    setSeverity(id);
  };

  const handleDueDateChange = (e) => {
    if (e.value) {
      setDueDate(String(Date.parse(e.value)));
    } else {
      setDueDate("");
    }
  };

  const viewerCallbacks = {
    measurementCreated: (measurement) => {
      const { _name } = measurement;
      if (_name === "CustomPinMarkup") {
        setPinStatus(() => "NOT_STARTED");
        measurement.setPinColor(new Communicator.Color(255, 0, 0));
        viewerImpl.activateOperator(Communicator.OperatorId.Select);
        setPinData(() => measurement.toJson());
      }
    },
  };

  useViewerCallbacks({ viewerCallbacks });

  const handleAddPin = () => {
    if (pinStatus == "NOT_STARTED") {
      setPinStatus("PENDING");
      viewerImpl.hwv.operatorManager.set(Communicator.OperatorId.CustomPinOperatorID, 1);
    } else {
      setPinStatus("NOT_STARTED");
      viewerImpl.activateOperator(Communicator.OperatorId.Select);
    }
  };

  const findMarkupByGuid = ({ guid }) => {
    const getAllMeasurements = viewerImpl.hwv.measureManager.getAllMeasurements();
    return getAllMeasurements.filter((record) => record._uniqueId == guid);
  };

  const handleRemovePin = () => {
    const markupsToRemove = findMarkupByGuid({
      guid: pinData._uniqueId,
    });
    markupsToRemove.forEach((markup) => viewerImpl.hwv.measureManager.removeMeasurement(markup));
    setPinData({});
  };

  const handleAddFile = () => {
    setShowFileManager(true);
  };

  const handleFileSelectedButtonClick = (params) => {
    const newData = [...issueAttachedFiles];
    Object.values(params).map((file) => {
      if (!newData.filter((a) => a.fileVersionId == file.fileVersion).length) {
        newData.push({
          name: file.name,
          fileVersionId: file.fileVersion,
          resourceType: file.resourceType,
          fileId: file.hierarchyId,
        });
      }
    });
    setIssueAttachedFiles(newData);
    setShowFileManager(false);
  };
  const handleFileCancelButtonClick = () => {
    setShowFileManager(false);
  };

  const handleRemoveAttachFile = (params) => {
    const { fileVersionId } = params.data;
    const tempAttachFiles = issueAttachedFiles.filter((data) => {
      if (data.fileVersionId != fileVersionId) {
        return true;
      }
      return false;
    });
    setIssueAttachedFiles(tempAttachFiles);
  };

  const handleAddPreFilledTag = (args) => {
    setCustomTag((prev) => [...prev, args.itemData]);
  };

  const handleRemoveCustomTag = (args) => {
    setCustomTag((prev) => prev.filter((tag) => tag != args.itemData.trim()));
  };

  const onSubmitFunction = async (base64EncodedImg) => {
    setImageForStandaloneIssue(base64EncodedImg);
    setStandaloneImageEdited(true);
  };

  const handleDeleteImage = async () => {
    setImageForStandaloneIssue("");
  };

  const statusDropdown = useCallback(
    () => (
      <DropDownListComponent
        name="status"
        ref={statusDropdownRef}
        value={Status?._id}
        actionComplete={actionComplete}
        dataSource={defaultListOfStatusAvailableService}
        query={query}
        onChange={handleStatusChange}
        itemTemplate={dropdownItemTemplate}
        fields={{ value: "_id", text: "name" }}
        buttonType={Status.background}
      />
    ),
    [Status, spaceId],
  );

  const severityDropdown = () => (
    <DropDownListComponent
      ref={steverityDropdownRef}
      value={severity}
      dataSource={severityTypes}
      onChange={handleSeverityChange}
      fields={{ value: "id", text: "text" }}
    />
  );

  return (
    <>
      <div className={css.createIssueParent} id="createIssueForm">
        <div className={css.createIssueBody} data-testid="createIssueBody">
          {props.isStandalone && (
            <div className="flex flex-col mb-8">
              <label className="text-sm pb-4 font-semibold" data-testid="imageTextLabel">
                {t("Image")}
              </label>
              <div className="w-74.96" data-testid="projectImageWrapper">
                <ImageEditor
                  isEditable
                  imageData={imageForStandaloneIssue}
                  onSubmitFunction={onSubmitFunction}
                  heading={t("Add Issue Image")}
                  onDelete={handleDeleteImage}
                />
              </div>
            </div>
          )}
          <div className="flex flex-col mb-8" data-testid="titleCreateIssue">
            <div className="flex">
              <label className="text-sm pb-4 font-semibold" data-testid="titleTextLabel">
                {t("Title")}
              </label>
              <span className="text-2xl align-middle font-light text-red-500">*</span>
            </div>
            <TextBoxComponent
              type="text"
              name="title"
              value={issueTitle}
              htmlAttributes={htmlAttributes}
              onChange={(e) => setIssueTitle(e.value)}
              floatLabelType="Always"
            />
          </div>
          <div className="flex flex-col mb-8" data-testid="descCreateIssue">
            <label className="text-sm pb-4 font-semibold" data-testid="descTextLabel">
              {t("Description")}
            </label>
            <RichTextEditorComponent
              toolbarSettings={{
                items: ["Bold", "Italic", "Underline", "Alignments", "Outdent", "Indent"],
              }}
              floatLabelType="Always"
              placeholder={t("Type something")}
              value={issueDescription}
              change={handleIssueDescriptionChange}
              height="150"
              showCharCount={false}
              toolbarBgColor="#f0f5f9"
              insertImageSettings={insertImageSettings}
            />
          </div>

          {spaceId ? (
            <div className="flex flex-col mb-8" data-testid="statusCreateIssue">
              <div className="flex">
                <label className="text-sm pb-4 font-semibold" data-testid="statusTextLabel">
                  {t("Status")}
                </label>
                <span className="text-2xl align-middle font-light text-red-500">*</span>
              </div>
              {statusDropdown()}
            </div>
          ) : undefined}

          <div className="flex flex-col mb-8" data-testid="severityCreateIssue">
            <label className="text-sm pb-4 font-semibold" data-testid="severityTextLabel">
              {t("Severity")}
            </label>
            {severityDropdown()}
          </div>

          <div className="flex flex-col mb-8" data-testid="dueDateCreateIssue">
            <label className="text-sm pb-4 font-semibold" data-testid="dueDateTextLabel">
              {t("Due Date")}
            </label>
            <DatePickerComponent
              value={dueDate && new Date(Number(dueDate))}
              floatLabelType="Always"
              onChange={handleDueDateChange}
              format="dd-MMM-yy"
            />
          </div>

          {!pdfRender && !props.isStandalone && (
            <div className={css.PinDataIssueDiv} data-testid="pinCreateIssue">
              <span className={css.labelPinData} data-testid="pinTextLabel">
                {t("Pin")}
              </span>
              {!Object.keys(pinData).length && (
                <ButtonComponent onClick={handleAddPin} buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}>
                  {pinStatus == "NOT_STARTED" ? t("Add pin") : t("Cancel pin")}
                </ButtonComponent>
              )}
              {Object.keys(pinData).length ? (
                <div className={css.pinChipData}>
                  <ChipListComponent id="chip-pin" enableDelete delete={handleRemovePin}>
                    <ChipsDirective>
                      <ChipDirective text={t("Pin")} />
                    </ChipsDirective>
                  </ChipListComponent>
                </div>
              ) : null}
            </div>
          )}

          {usersList ? (
            <div className="flex flex-col mb-8" data-testid="assignedToCreateIssue">
              <label className="text-sm pb-4 font-semibold" data-testid="assignedToTextLabel">
                {t("Assigned to")}
              </label>
              <DropDownListComponent
                value={assignedTo}
                fields={{ text: "userName", value: "userId" }}
                dataSource={spaceUsersListService}
                query={new Query().where("spaceId", "equal", spaceId)}
                onChange={(e) => setAssignedTo(e.target.value)}
                floatLabelType="Always"
                buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
              />
            </div>
          ) : null}

          <div className="flex flex-col mb-8" data-testid="attachmentsCreateIssue">
            <label className="text-sm pb-4 font-semibold" data-testid="attachmentsTextLabel">
              {t("Attachments")}
            </label>
            <Box onClick={handleAddFile} className={css.attachFileBody} data-testid="handleAddFile">
              <div className={css.attachFileBodyContent} data-testid="attachFileBodyContent">
                <span data-testid="attachFileText">{t("Attach File")}</span>
                <IconComponent name="attachFile" className="w-5 h-5" />
              </div>
            </Box>

            <div className="attachedFilesList" data-testid="attachFileList">
              <ChipListComponent id="chip-attach-files" enableDelete delete={handleRemoveAttachFile}>
                <ChipsDirective>
                  {issueAttachedFiles?.map((data) => {
                    const loadingUrl = getFileImage(data);
                    return (
                      <ChipDirective
                        key={data.fileVersionId}
                        fileVersionId={data.fileVersionId}
                        text={data.name}
                        leadingIconUrl={loadingUrl}
                      />
                    );
                  })}
                </ChipsDirective>
              </ChipListComponent>
            </div>
          </div>

          <div className="flex flex-col mb-8" data-testid="addTagsCreateIssue">
            <label className="text-sm pb-4 font-semibold" data-testid="addTagsTextLabel">
              {t("Add Tags")}
            </label>
            <MultiSelectComponent
              enabled
              dataSource={tagsDataSource}
              value={initialCustomTags}
              mode="Box"
              placeholder={t("Add a Tag")}
              allowCustomValue
              select={handleAddPreFilledTag}
              removed={handleRemoveCustomTag}
            />
          </div>

          {Object.keys(formTemplate).length > 0 && (
            <Accordion defaultExpanded>
              <AccordionSummary>
                <div className="flex justify-between w-full py-3 items-center">
                  <span className="text-xl font-semibold">{t("Custom Fields")}</span>
                  <span>
                    <IconComponent name="arrowDown" cssClass="cursor-pointer" />
                  </span>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="flex flex-col mb-8">
                  {!props.clashIssueData && (
                    <FormPreview
                      formData={formTemplate}
                      formValidator={formValidator}
                      allowPadding={false}
                      allowBorder={false}
                      projectId={projectData._id}
                      disabled={false}
                      handleData={handleCustomFieldsData}
                      headingFontSize="text-lg"
                      fullWidthInput
                      removeIcons
                    />
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
          )}
        </div>

        <div className="flex justify-start gap-6 mt-6" data-testid="IssuesButton">
          <ButtonComponent
            buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
            onClick={handleCreateIssue}
            disabled={actionButtons}
          >
            {createButton}
          </ButtonComponent>
          <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={handleCancelIssue} disabled={actionButtons}>
            {t("Cancel")}
          </ButtonComponent>
        </div>
      </div>
      {showFileManager && (
        <FileManagerAsPopup
          projectId={projectData._id}
          handleFileSelectedButtonClick={handleFileSelectedButtonClick}
          handleFileSelectedCancelClick={handleFileCancelButtonClick}
          workspaceId={spaceId}
          id="fileManagerAsPopup"
          wrapperStyles={{
            fileManagerModalOverlayWrapper: css.fileManagerModalOverlayWrapper,
          }}
          hideIssues
          hideTasks
          hideSchedules
          hideEstimates
          hideExternalSpace
          heading={t("Attach Files")}
          disableFiles={[]}
        />
      )}
      {props.triggerClashIssue && (
        <div className="fixed top-0 end-0 h-full w-full z-50 opacity-80 bg-black content-center text-center text-white">
          <div>{t("Kindly do not close the tab")}</div>
          <div>{t("Please wait while creating clash issue")}</div>
          {clashIssueProgress && (
            <>
              <div>{`${clashIssueProgress.progress} ${t("out of")} ${clashIssueProgress.total} ${t(
                "issue created",
              )}`}</div>
              <ButtonComponent
                onClick={() => {
                  setCancelClashIssue(true);
                }}
                buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
              >
                {cancelClashIssue ? t("Cancelling!") : t("Cancel")}
              </ButtonComponent>
            </>
          )}
        </div>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  editIssues: state.editIssues,
  spacesUsersData: state.spacesUsersData,
  filesData: state.filesData,
  transmittals: state.transmittals,
});

const mapDispatchToProps = (dispatch) => ({
  saveIssuesData: (params, id) => dispatch(saveIssuesData(params, id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateIssue);
